const routes = [
  {
    index: true,
    label: 'Caleb Qi',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Stats',
    path: '/stats',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
  // {
  //   label: 'Writing',
  //   path: '/writing',
  // },
];

export default routes;
